export const BADGE_VARIANTS = {
  danger: "danger",
  info: "info",
  success: "success",
  warning: "warning",
  light: "light",
} as const;

export type VariantType = keyof typeof BADGE_VARIANTS;
